import { FilterService } from 'primeng/api';

/**
 * Modo de filtrado registrado en el `FilterService` de PrimeNG para los
 * selectores de personas. Se usa como `filterMatchMode="nameTokens"`.
 */
export const NAME_TOKENS_MATCH_MODE = 'nameTokens';

/**
 * Deja el texto comparable: sin acentos, en minúsculas y con los espacios
 * colapsados. "Pérez  de la O" -> "perez de la o".
 */
export function normalizeText(value: unknown): string {
    if (value === null || value === undefined) {
        return '';
    }
    return value
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
}

/**
 * Verdadero si **cada** palabra de la búsqueda aparece en el texto, sin importar
 * el orden ni que estén juntas. Así "Alejandro Pérez" o "Alejandro de la O"
 * encuentran a "Alejandro Juan Pérez de la O".
 */
export function matchesNameTokens(value: unknown, query: string): boolean {
    const tokens = normalizeText(query).split(' ').filter(Boolean);
    if (!tokens.length) {
        return true;
    }
    const target = normalizeText(value);
    if (!target) {
        return false;
    }
    return tokens.every((token) => target.includes(token));
}

/** Registra `nameTokens` una sola vez, al arrancar la app. */
export function registerNameTokensFilter(filterService: FilterService): void {
    filterService.register(NAME_TOKENS_MATCH_MODE, (value: any, filter: any): boolean => {
        if (filter === undefined || filter === null || filter.toString().trim() === '') {
            return true;
        }
        if (value === undefined || value === null) {
            return false;
        }
        return matchesNameTokens(value, filter.toString());
    });
}
